export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11785.688b1c69.jpg";